export default function aliasFromUsername(username)  {
    let usernameArr = username.trim().split(' ')
    return usernameArr.length > 1 ? usernameArr[0][0]?.toUpperCase() + usernameArr[1][0] : (usernameArr[0][0]?.toUpperCase() + usernameArr[0][1] || "")

}